<template>
  <div
    v-if="isModalOpen"
    id="lang-modal"
    class="modal small-modal"
    :style="{ display: 'block' }"
    @click.self="closeModal"
  >
    <div class="modal-content-container">
      <div class="modal-content small">
        <div id="close-modal" class="close" @click="closeModal">
          <IconCloseLarge :width="40" :height="40" fill="#BFBFBF" />
        </div>
        <h3 class="lang-option-title">{{ t("selectLanguage") }}</h3>
        <div class="radio-container">
          <div
            v-for="language in languages"
            :key="language.code"
            class="radio-option"
          >
            <input
              type="radio"
              :id="`lang-${language.code}`"
              name="language"
              :value="language.code"
              v-model="selectedLanguage"
              @change="confirmSelection"
            />
            <label :for="`lang-${language.code}`">
              <img
                :src="getFlagUrl(language.flag)"
                :alt="`${language.name} Flag`"
              />
              <span>{{ language.name }}</span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, defineEmits, defineProps, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useSystemSettingsStore } from "@/stores/systemSettings";
import { useLanguage } from "@/composables/useLanguage";
import IconCloseLarge from "@/components/icons/iconCloseLarge.vue";

const props = defineProps({
  isOpen: { type: Boolean, required: true },
});

const emit = defineEmits(["update:isOpen"]);

const { t, locale } = useI18n();

const { getAvailableLanguages, getFlagUrl } = useLanguage();
const { getLanguage, setLanguage } = useSystemSettingsStore();

const isModalOpen = computed(() => props.isOpen);
const systemLanguage = computed(() => getLanguage());

const languages = ref(getAvailableLanguages());
const selectedLanguage = ref(systemLanguage.value.code);

const confirmSelection = () => {
  const langObj = languages.value.find(
    (lang) => lang.code === selectedLanguage.value
  );
  if (langObj) {
    setLanguage(langObj);
    locale.value = langObj.code;
  }
  closeModal();
};

const closeModal = () => {
  emit("update:isOpen", false);
};
</script>
